// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3XUxD","header":"MergedInvoice_header__33iYj"};